import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as d, useState as s, useCallback as f } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { isCapitalRegionSupported as N } from "../../../../internal/CapitalHeader/helpers.js";
import { CapitalErrorMessageDisplay as T } from "../utils/CapitalErrorMessageDisplay.js";
import { CAPITAL_OFFER_CLASS_NAMES as g } from "./constants.js";
import { CapitalOfferSelection as k } from "../CapitalOfferSelection/CapitalOfferSelection.js";
import { useFetch as B } from "../../../../../hooks/useFetch.js";
import { CapitalOfferSummary as H } from "../CapitalOfferSummary/CapitalOfferSummary.js";
/* empty css                  */
import { CapitalHeader as C } from "../../../../internal/CapitalHeader/CapitalHeader.js";
import { useConfigContext as E } from "../../../../../core/ConfigContext/context.js";
import { EMPTY_OBJECT as K } from "../../../../../utils/value/constants.js";
const V = ({
  externalDynamicOffersConfig: a,
  hideTitle: m,
  onContactSupport: c,
  onFundsRequest: A,
  onOfferDismiss: F,
  onOfferSelect: n
}) => {
  var S, y;
  const { getDynamicGrantOffersConfiguration: t } = E().endpoints, l = (y = (S = E()) == null ? void 0 : S.extraConfig) == null ? void 0 : y.legalEntity, u = d(() => N(l), [l]), [b, p] = s(!1), h = f((e) => {
    p(!e);
  }, []), { data: R, error: q } = B({
    fetchOptions: {
      enabled: !a && !!t && u,
      onSuccess: h
    },
    queryFn: f(async () => t == null ? void 0 : t(K), [t])
  }), v = a || R, [i, O] = s(), [M, _] = s(), x = f(
    (e) => {
      n ? n(e) : (_(e == null ? void 0 : e.grantAmount.value), O(e));
    },
    [n]
  ), o = d(() => i ? "OfferSummary" : "OfferSelection", [i]);
  return u ? /* @__PURE__ */ r("div", { className: g.base, children: [
    /* @__PURE__ */ r(
      C,
      {
        hasDivider: !0,
        hideTitle: m,
        titleKey: o === "OfferSummary" ? "capital.businessFinancingSummary" : "capital.businessFinancingOffer"
      }
    ),
    o === "OfferSelection" && /* @__PURE__ */ r(
      k,
      {
        requestedAmount: M,
        dynamicOffersConfig: v,
        dynamicOffersConfigError: q,
        onOfferDismiss: F,
        onOfferSelect: x,
        emptyGrantOffer: b,
        onContactSupport: c
      }
    ),
    o === "OfferSummary" && /* @__PURE__ */ r(
      H,
      {
        grantOffer: i,
        onBack: () => O(void 0),
        onFundsRequest: A,
        onContactSupport: c
      }
    )
  ] }) : /* @__PURE__ */ r("div", { className: g.errorContainer, children: [
    /* @__PURE__ */ r(C, { hideTitle: m, titleKey: "capital.businessFinancing" }),
    /* @__PURE__ */ r(T, { unsupportedRegion: !0 })
  ] });
};
export {
  V as CapitalOffer
};
